import logoNegro from '../../img/logo.png';
import './style.css';
import iconBusqueda from '../../img/lupaNegra.png';
import logoMoradoDegradado from '../../img/logoDegradadoMorado.png';
import imgAirpods from '../../img/inicio/airpods.webp';
import imgJBL from '../../img/inicio/jbl.jpg';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

function NuestroTrabajo(props) {
    const history = useHistory();

    const handleClick = () => {
        history.push('/'); // cambia a la ruta deseada
    };

    return (  
        <div className={`nuestroTrabajo`}>
            <img src={logoMoradoDegradado} alt="" className='fondoNuestroTrabajo'/>
            <div className="row rowLogo">
                <div className="col-4 col-sm-3 col-md-2 col-lg-1 m-0 p-0 d-none d-sm-flex">
                    <img src={logoNegro} alt="" width={'70%'} className='mb-0 mt-auto' onClick={handleClick} style={{ cursor: 'pointer' }}/>
                </div>
            </div>
            <div className="row rowBusqueda d-none d-sm-flex" onClick={() => props.showBusqueda === false && props.setShowBusqueda(true)}>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <img src={iconBusqueda} alt="" className='iconBusqueda'/>
                    </div>
                    <input type="text" className="form-control" placeholder={`${props.showBusqueda ? 'Buscar' : '2D'}`} aria-label="Username" aria-describedby="basic-addon1" readOnly={!props.showBusqueda}/>
                </div>
            </div>
            <div className="row rowProyectos mt-5 animate__animated animate__fadeIn animate__faster">
                <div className="col-lg-4 p-0">
                    <div className="cardSM">
                        <img src={imgAirpods} alt="" />
                        <div className='contenedorBoton'>
                            <Link className='btnSM' to={'/proyecto'}>Lorem impsun</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-1 p-0"></div>
                <div className="col-lg-7 mt-5 mt-lg-0 p-0">
                    <div className="cardL">
                        <img src={imgJBL} alt="" />
                        <div className='contenedorBoton'>                            
                            <Link className='btnL' to={'/proyecto'}>Lorem impsun</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row rowProyectos mt-5 animate__animated animate__fadeIn animate__faster">
                <div className="col-lg-7 p-0">
                    <div className="cardL">
                        <img src={imgJBL} alt="" />
                        <div className='contenedorBoton'>                            
                            <Link className='btnL' to={'/proyecto'}>Lorem impsun</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-1 p-0"></div>
                <div className="col-lg-4 mt-5 mt-lg-0 p-0">
                    <div className="cardSM">
                        <img src={imgAirpods} alt="" />
                        <div className='contenedorBoton'>
                            <Link className='btnSM' to={'/proyecto'}>Lorem impsun</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row rowProyectos mt-5 mb-5 animate__animated animate__fadeIn animate__faster">
                <div className="col-lg-4 p-0">
                    <div className="cardSM">
                        <img src={imgAirpods} alt="" />
                        <div className='contenedorBoton'>
                            <Link className='btnSM' to={'/proyecto'}>Lorem impsun</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-1 p-0"></div>
                <div className="col-lg-7 mt-5 mt-lg-0 p-0">
                    <div className="cardL">
                        <img src={imgJBL} alt="" />
                        <div className='contenedorBoton'>                            
                            <Link className='btnL' to={'/proyecto'}>Lorem impsun</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NuestroTrabajo;